module.exports = __webpack_public_path__ + "img/community07.153984cf.png";